export const SITEINFO_CHECKLIST = "SITEINFO_CHECKLIST";
